module.exports = __webpack_public_path__ + "static/img/blue-bg.9249c80f.jpg";